import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import LeftSideNavigation from "./navigationSection/LeftSideNavigation";
import RightSideNavigation from "./navigationSection/RightSideNavigation";
import CallingButtonPopup from "../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../reusableComponents/allPopupReusable/NotificationButton";
// import ChatButtonPopup from "../reusableComponents/allPopupReusable/ChatButtonPopup";
import ViewButtonPopup from "../reusableComponents/allPopupReusable/ViewButtonPopup";
import DeletePopup from "../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import ReusableSuccessMessage from "../reusableComponents/allPopupReusable/successMesagePopup/ReusableSuccessMessage";
import EnterTableNumber from "../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";
import ReasonForCancellation from "../reusableComponents/allPopupReusable/reasonForCancellation/ReasonForCancellation";
import EditWaitTime from "../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import SetWaitTime from "../reusableComponents/allPopupReusable/tableNumberPopup/SetWaitTime";
import LocationReusable from "../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import RequestAcceptAndCancelled from "../reusableComponents/allPopupReusable/RequestAcceptAndCancelled";
import TableSizePopup from "../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import { SeatingStatus } from "../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";
import Filter from "../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import OfferPopup from "../reusableComponents/allPopupReusable/offerEventPopup/OfferPopup";
import EventPopup from "../reusableComponents/allPopupReusable/offerEventPopup/EventPopup";
import IncrementDecrement from "../reusableComponents/incrementDecrement/IncrementDecrement";
import { IconBoxReusableComponent } from "../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
import AddDinerPopup from "../reusableComponents/allPopupReusable/addDinerAndAddReservation/AddDinerPopup";
import EditDiner from "../reusableComponents/allPopupReusable/editDinerAndEditReservaion/EditDiner";
import EditReservation from "../reusableComponents/allPopupReusable/editDinerAndEditReservaion/EditReservation";

export class DisplayPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation displayButton="addDiner" />
              {/* <IconReusableComponent
                iconImage={require("../../../assets/images/ActionImages/eventwhite.svg")}
                iconImageAlt="Event Logo"
                iconImageTitle="Event"
                iconText="Event"
              /> */}
              <div className="row mb-4">
                <div className="col">
                  <CallingButtonPopup buttonClass="smallButton" />
                </div>
                <div className="col">
                  <SendSmsButton buttonClass="smallButton" />
                </div>
                <div className="col">
                  <NotificationButton buttonClass="smallButton" />
                </div>
                <div className="col">
                  <ViewButtonPopup buttonClass="smallButton" />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col">
                  <DeletePopup
                    buttonDisplay="deleteButton"
                    buttonText="Delete"
                    bigText="Are you sure you want to Delete ?"
                  />
                </div>
                <div className="col">
                  <DeletePopup
                    buttonDisplay="deleteButton"
                    buttonText="Reset"
                    bigText="Are you sure to Reset ?"
                  />
                </div>
                <div className="col">
                  <DeletePopup
                    buttonDisplay="deleteButton"
                    buttonText="Complete Record"
                    bigText="Are you sure to Complete All Seated Records ?"
                  />
                </div>
                <div className="col">
                  <DeletePopup
                    buttonDisplay="deleteButton"
                    buttonText="UnSeat"
                    bigText="Are you sure to UnSeat ?"
                  />
                </div>
                <div className="col">
                  <DeletePopup
                    buttonDisplay="deleteButton"
                    buttonText="Reject"
                    bigText="Are you sure to Reject ?"
                  />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col">
                  <DeletePopup
                    buttonDisplay="deleteButton"
                    buttonText="Cancel"
                    bigText="Are you sure to Cancel ?"
                  />
                </div>
                <div className="col">
                  <EnterTableNumber
                    buttonText="Enter Table Number"
                    buttonClass="cancel"
                  />
                </div>
                <div className="col">
                  <ReusableSuccessMessage
                    display={false}
                    buttonText="Sms"
                    bigText="Send SMS"
                    smallText="SMS sent to"
                    successText="Shubham"
                  />
                </div>
                <div className="col">
                  <ReusableSuccessMessage
                    display={false}
                    buttonText="Notification"
                    bigText="Push Notification"
                    smallText="Push Notification sent to"
                    successText="Shubham"
                  />
                </div>
                <div className="col">
                  <ReusableSuccessMessage
                    display={true}
                    buttonText="Record Success"
                    bigText=""
                    smallText="No more requests to be completed"
                  />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col">
                  <ReasonForCancellation buttonText="Reason for Cancellation" />
                </div>
                <div className="col">
                  <EditWaitTime buttonText="Edit wait Time" />
                </div>
                <div className="col">
                  <SetWaitTime buttonText="Set wait time" />
                </div>
                <div className="col">
                  <LocationReusable buttonText="Location" />
                </div>
              </div>
              <div className="row mb-4">
                <div className="col">
                  <RequestAcceptAndCancelled
                    buttonText="Requested Seated"
                    bigText="Requested Seated"
                    leftButton="unseat"
                    rightButton="complete"
                    status="Seated"
                  />
                </div>
                <div className="col">
                  <RequestAcceptAndCancelled
                    buttonText="Request Rejected"
                    bigText="Request Rejected"
                    leftButton="reset"
                    status="Rejected"
                  />
                </div>
                <div className="col">
                  <RequestAcceptAndCancelled
                    buttonText="Request Completed"
                    bigText="Request Completed"
                    leftButton="reset"
                    status="Completed"
                  />
                </div>
                <div className="col">
                  <RequestAcceptAndCancelled
                    buttonText="Requested Accepted"
                    bigText="Requested Accepted"
                    leftButton="cancel"
                    rightButton="seat"
                    status="Not Seated"
                  />
                </div>
                <div className="col">
                  <RequestAcceptAndCancelled
                    buttonText="Request Cancelled"
                    bigText="Request Cancelled"
                    leftButton="reset"
                    status="Cancelled"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <TableSizePopup buttonText="Table Size" />
                </div>
                <div className="col">
                  <SeatingStatus buttonText="Seating Status" />
                </div>
                <div className="col">
                  <Filter buttonText="Filter" />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <OfferPopup buttonText="Add Offer" bigText="New Offer" />
                </div>
                <div className="col">
                  <EventPopup buttonText="Add Event" bigText="New Event" />
                </div>
                <div className="col">
                  <IncrementDecrement
                    iconImage={require("../../assets/images/AuthImages/employees.svg")}
                    title="Adult"
                    iconText="Adults"
                  />
                </div>
                <div className="col">
                  <IconBoxReusableComponent
                    classSection="seating-Iconbox-reusable"
                    src={require("../../assets/images/AuthImages/employees.svg")}
                    title="employee"
                    iconText="Any"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <AddDinerPopup buttonText="Add Diner" />
                </div>
                <div className="col">
                  <EditDiner buttonText="Edit Diner" bigText="Edit Diner" />
                </div>
                <div className="col">
                  <EditReservation
                    buttonText="Edit Reservation"
                    bigText="Edit Reservation"
                  />
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default DisplayPage;

//05-06-2020 13:49pm
